import { render, staticRenderFns } from "./PackageListAddNew.vue?vue&type=template&id=2fcdf55e&"
import script from "./PackageListAddNew.vue?vue&type=script&lang=js&"
export * from "./PackageListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PackageListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports